import { useState, useEffect, useRef } from 'react';
import api from '../../services/api';

const INPUT = 'w-full px-3 py-2 bg-dark-700 border border-dark-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm';

export default function InstrumentPicker({ value, onChange, excludeTag, placeholder = 'Ex: ABC-1234' }) {
  const [query, setQuery] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);

  useEffect(() => {
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const search = (q) => {
    clearTimeout(timer.current);
    if (!q.trim()) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try {
        const res = await api.get(`/instruments/tags?q=${encodeURIComponent(q)}`);
        const filtered = excludeTag ? res.data.filter(i => i.tag !== excludeTag) : res.data;
        setResults(filtered);
        setOpen(filtered.length > 0);
      } catch { setResults([]); }
    }, 300);
  };

  const handleChange = (e) => {
    const v = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
    setQuery(v);
    onChange(v);
    search(v);
  };

  const select = (tag) => {
    setQuery(tag);
    onChange(tag);
    setResults([]);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <input
        type="text"
        value={query}
        onChange={handleChange}
        onFocus={() => query && results.length > 0 && setOpen(true)}
        placeholder={placeholder}
        className={INPUT}
      />
      {open && (
        <div className="absolute z-50 w-full bg-dark-800 border border-dark-500 rounded-lg mt-1 max-h-48 overflow-y-auto shadow-xl">
          {results.map(r => (
            <div
              key={r.tag}
              className="px-3 py-2 cursor-pointer text-sm hover:bg-dark-700 flex items-center gap-2"
              onMouseDown={(e) => { e.preventDefault(); select(r.tag); }}
            >
              <span className="text-blue-400 font-mono font-semibold">{r.tag}</span>
              <span className="text-dark-400 text-xs truncate">{r.description}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
